import { PosIconProps, SvgWrapper } from 'src/svgs/SvgWrapper';

export function ChevronRightIconV2(props: PosIconProps) {
  return (
    <SvgWrapper
      aria-label="ChevronLeftIcon"
      fill="currentColor"
      {...props}
      viewBox="6 6 6 10"
      style={{ transform: 'scaleX(-1)' }}
    >
      <path d="M13.916 15.6668L12.7495 16.9158L8.08452 11.9193L8.08752 11.9158L8.08452 11.9123L12.7495 6.91577L13.916 8.16477L10.414 11.9158L13.916 15.6668Z" />
    </SvgWrapper>
  );
}
